import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
export var shouldShowImprintPage = function() {
    var _getLocaleKey;
    var countryCode = isLoggedInRetailer() ? RetailerStore.get().retailerCountry : getSessionCountry();
    return countryCode === THREE_LETTER_PRIMARY_COUNTRY_CODES.DEU && ((_getLocaleKey = getLocaleKey()) === null || _getLocaleKey === void 0 ? void 0 : _getLocaleKey.language) === Language.DEU;
};
